(function($) {
    'use strict';
	// One-time nonce refresh and retry helper
	function ajaxWithNonceRetry(options) {
		let tried = false;
		const originalError = options.error;
		const originalData = options.data;

		function withNonce(data, nonce) {
			if (data instanceof FormData) {
				if (data.has('_nonce')) data.set('_nonce', nonce); else data.append('_nonce', nonce);
				return data;
			}
			if (typeof data === 'string') {
				if (/([?&])_nonce=/.test(data)) {
					return data.replace(/([?&]_nonce=)[^&]*/, '$1' + encodeURIComponent(nonce));
				}
				return (data ? data + '&' : '') + '_nonce=' + encodeURIComponent(nonce);
			}
			if (typeof data === 'object' && data !== null) {
				data._nonce = nonce;
				return data;
			}
			return { _nonce: nonce };
		}

		options.error = function(jqXHR, textStatus, errorThrown) {
			if (!tried && jqXHR.status === 401) {
				tried = true;
				$.post('admin-ajax.php', { action: 'pixjet_refresh_nonce' })
					.done(function(resp) {
						if (resp && resp.nonce) {
							pixjet.nonce = resp.nonce;
							options.data = withNonce(originalData, pixjet.nonce);
							$.ajax(options);
						} else {
							originalError && originalError(jqXHR, textStatus, errorThrown);
						}
					})
					.fail(function() {
						originalError && originalError(jqXHR, textStatus, errorThrown);
					});
			} else {
				originalError && originalError(jqXHR, textStatus, errorThrown);
			}
		};

		options.data = withNonce(originalData, pixjet.nonce);
		return $.ajax(options);
	}

    // Chart Management
    let charts = { imgHistory: false, cdnHistory: false };

    // Format date function
    function formatDate(inputDate) {
        if (!inputDate) return;
        let [year, month, day] = inputDate.split('-');
        let date = new Date(year, month - 1, day);
        let dayNumber = date.getDate();
        let monthShort = new Intl.DateTimeFormat('en-GB', { month: 'short' }).format(date);
        return `${dayNumber} ${monthShort}`;
	}
	
	function enablePro() {
		$("select option").each(function() {
            if ($(this).text().match(/paid|pro/i)) {
                $(this).attr('disabled', false);
            }
        });
		$(".watermark-alignment label").each(function() {
            if ($(this).hasClass('pro')) {
				$(this).removeClass('pro');
				$(this).find('span').text('').removeClass('badge').addClass('radio');
            }
		});
	}

	function disablePro() { 
        $("select option").each(function() {
            if ($(this).text().match(/paid|pro/i)) {
                $(this).attr('disabled', 'disabled');
            }
        });

        $(".watermark-alignment label").each(function() {
            if ($(this).hasClass('pro')) {
                $(this).attr('disabled', 'disabled')
					.find('span')
					.removeClass('radio')
					.addClass('badge')
					.text('pro');
            } else {
				$(this).find('span')
					.text('')
					.removeClass('badge')
					.addClass('radio');
                $(this).attr('disabled', false);
            }
		});
	}


	function batchOptimize() {
		// Initialize progress bar and counter
		let ids = $("#hidden_ids").val().split(",").filter(Boolean);
		let total = ids.length;
		let completed = 0;
		let failed = 0;
		// Determine concurrency: pro = 6 at a time; free = 1
		let plan = $("#is_pro").val();
		let concurrency = (plan === 'pro') ? 6 : 1;
		let active = 0;
		
	
		// Show SweetAlert2 modal
		Swal.fire({
			title: 'Processing Requests',
			html: `
				<div id="progress-container" style="margin-top: 20px;">
					<div id="progress-bar" style="width: 0%; height: 20px; background-color: #4caf50; border-radius: 5px;"></div>
				</div>
				<p id="progress-text" style="margin-top: 10px;">0 / ${total}</p>
			`,
			allowOutsideClick: false,
			showConfirmButton: false,
			didOpen: () => {
				// Start processing each ID
				sendRequests();
			},
		});
	
		// Function to manage a pool of concurrent AJAX requests
		function sendRequests() {
			// If nothing left to start and no active requests, we're done
			if (ids.length === 0 && active === 0) {
				const title = failed > 0 ? 'Completed with some errors' : 'All Requests Completed';
				const icon = failed > 0 ? 'warning' : 'success';
				const text = failed > 0 ? `Processed ${total} items. Success: ${completed}, Failed: ${failed}` : `Processed ${total} items successfully!`;
				Swal.fire({ icon, title, text });
				setTimeout(() => { window.location.reload(); }, 3000);
				return;
			}

			// Start up to 'concurrency' requests
			while (active < concurrency && ids.length > 0) {
				let id = ids.shift();
				active++;
				ajaxWithNonceRetry({
					url: 'admin-ajax.php',
					type: 'POST',
					data: {
						action: 'pixjet_ajax',
						PixJet_page: 'pixjet_batch_optimize',
						id: id
					},
					success: function() {
						completed++;
						updateProgress();
					},
					error: function(err) {
						failed++;
						console.error('Batch optimize failed for ID', id, err);
						updateProgress();
					}
				}).always(function() {
					active--;
					// Try to launch more requests or finish
					sendRequests();
				});
			}
		}

		function updateProgress() {
			let progress = total === 0 ? 100 : Math.round(((completed + failed) / total) * 100);
			$("#progress-bar").css("width", `${progress}%`);
			$("#progress-text").text(`${completed} / ${total} (failed: ${failed})`);
		}
	}

	function rollbackOptimize() { 
		// swal confirm
		Swal.fire({
			title: 'Are you sure?',
			text: "You are about to rollback all images to their original state.",
			icon: 'warning',
			allowOutsideClick: false,
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, rollback it!',
		}).then((result) => {
			if (result.isConfirmed) {
				$("#pixjet_loader").show();
				$.ajax({
					url: 'admin-ajax.php',
					method: 'POST',
					data: {
						action: 'pixjet_ajax',
						PixJet_page: "rollback",
						_nonce: pixjet.nonce,
					},
					success: () => {
						$("#pixjet_loader").hide();
						Swal.fire({
							icon: 'success',
							title: 'Rollback Completed',
							text: 'All images have been restored to their original state.',
						});
						setTimeout(() => { window.location.reload(); }, 3000);
					},
					error: (err) => {
						$("#pixjet_loader").hide();
						var msg = err.responseJSON?.message ?? 'Failed to rollback images';
						Swal.fire({
							icon: 'error',
							title: 'Error',
							text: msg,
						});
					},
				});
			}
		});
	}

    // Create or update chart
    function makeChart(id, x, y1, y2) {
        let chartOptions = {
            chart: {
                type: 'line',
                height: 300,
                id: id,
                animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: { speed: 1000 }
                },
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: true,
                        reset: true
                    }
                }
            },
            stroke: { curve: 'smooth' },
            dataLabels: { enabled: true },
            series: [
                { name: y1.label, data: y1.data },
                { name: y2.label, data: y2.data }
            ],
            xaxis: {
                categories: x,
                labels: { formatter: function(value) { return formatDate(value); }}
            },
            // yaxis: { logarithmic: true, logBase: 2 }
        };
        if (charts[id]) {
            charts[id].updateSeries([
                { name: y1.label, data: y1.data },
                { name: y2.label, data: y2.data }
            ]);
        } else {
            charts[id] = new ApexCharts(document.querySelector(`#${id}`), chartOptions);
            charts[id].render();
        }
    }

    // Dashboard Data Fetcher
    function pixjet_getDashboard() {
		return ajaxWithNonceRetry({
            url: 'admin-ajax.php',
            type: 'POST',
            dataType: 'json',
			data: { action: 'pixjet_api_status' }
		}).done(function (data) {
			$("#pixjet_loader").hide();
			var img = data?.convert?.usages;
			var cdn = data?.cdn?.usages;
			if (img && $("#imgHistory").length) {
				makeChart('imgHistory', img?.dates, { label: 'WEBP', data: img?.webp }, { label: 'AVIF', data: img?.avif });
			}
			if (cdn && $("#cdnHistory").length) {
				makeChart('cdnHistory', cdn?.dates, { label: 'Requests', data: cdn?.requests }, { label: 'Bandwidth (GB)', data: cdn?.bandwidth });
			}
			if (data?.user) {
				$("#pixjet_email").text(data.user.email);
				if (data?.package === 'pro') {
					enablePro();
				} else {
					disablePro();
				}
			}
			if (data?.overviews?.mb) {
				$(".pj-stats-mb .stat-title").html(data?.overviews?.mb[0]);
				$(".pj-stats-mb .stat-data").html(data?.overviews?.mb[1]);
			}
			if (data?.overviews?.saved) {
				$(".pj-stats-saved .stat-title").html(data?.overviews?.saved[0]);
				$(".pj-stats-saved .stat-data").html(data?.overviews?.saved[1]);
			}
			if (data?.overviews?.req) {
				$(".pj-stats-req .stat-title").html(data?.overviews?.req[0]);
				$(".pj-stats-req .stat-data").html(data?.overviews?.req[1]);
			}
			if (data?.overviews?.img) {
				$(".pj-stats-img .stat-title").html(data?.overviews?.img[0]);
				$(".pj-stats-img .stat-data").html(data?.overviews?.img[1]);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			$("#pixjet_loader").hide();
			if (jqXHR.status === 401) { 
				window.location.reload();
			}
            console.error('Ajax failed:', textStatus, errorThrown);
        });
    }

	$(document).ready(function () {
	
		// Load Dashboard Data
		if (pixjet?.auth == '1') {
			if ($("#pixjet_stats_loader").val() == 'yes') {
				pixjet_getDashboard();
				setInterval(() => { pixjet_getDashboard(); }, 1000 * 60);
			} else {
				$("#pixjet_loader").hide();
			}
		} else {
			$("#pixjet_loader").hide();
		}

        // Optimization Settings Form Submission
		$('#optimization_setting').on('submit', function(e) {
            $("#pixjet_loader").show();
			e.preventDefault();
			var data = $(this).serialize();
			ajaxWithNonceRetry({
                method: 'POST',
                url: 'admin-ajax.php',
                data: data,
                dataType: 'json',
                success: function(data) {
                    $("#pixjet_loader").hide();
                    Swal.fire({
                        title: 'Success!',
                        text: 'Settings saved successfully',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                },
                error: function(data) {
                    $("#pixjet_loader").hide();
                    var message = data.responseJSON?.message ?? 'Validation failed, Please reload the page and try again.';
                    Swal.fire({
                        title: 'Error!',
                        text: message,
                        icon: 'error',
                        confirmButtonText: 'OK'
					});
                }
            });
        });

        // CDN Settings Handler
        $(".cdn_setting").on('click', function(e) {
            e.preventDefault();
            var type = $(this).data('type');
            Swal.fire({
                title: 'Are you sure?',
                text: "You are about to " + type + " the CDN.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, ' + type + ' it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    $("#pixjet_loader").show();
                    ajaxWithNonceRetry({
                        method: "POST",
                        url: "admin-ajax.php",
                        data: {
                            action: 'pixjet_ajax',
                            PixJet_page: "cdn",
							cdn: type,
                        },
                        dataType: 'json',
                        success: function(data) {
                            $("#pixjet_loader").hide();
                            type = (type == 'enable') ? 'enabled' : 'disabled';
                            Swal.fire({
                                title: 'Success!',
                                text: 'CDN ' + type + ' successfully! Please clear your cache to see the changes.',
                                icon: 'success',
                                confirmButtonText: 'OK'
							});
							setTimeout(() => {
								window.location.reload();
							}, 2000);
                        },
                        error: function(data) {
                            $("#pixjet_loader").hide();
                            var message = data.responseJSON?.message ?? 'Validation failed, Please reload the page and try again.';
                            Swal.fire({
                                title: 'Error!',
                                text: message,
                                icon: 'error',
                                confirmButtonText: 'OK'
							});
                        }
                    });
                }
            });
        });

        // Watermark Form Submission
        $("#watermark_form").on('submit', function(e) {
            e.preventDefault();
			var formData = new FormData(this);
			formData.append('_nonce', pixjet.nonce);
            $("#pixjet_loader").show();
			ajaxWithNonceRetry({
                method: "POST",
                url: "admin-ajax.php",
                data: formData,
                dataType: 'json',
                contentType: false,
                processData: false, 
                success: function(data) {
                    $("#pixjet_loader").hide();
                    Swal.fire({
                        title: 'Success!',
                        text: 'Watermark settings saved successfully',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                    if(data?.logo) {
                        $('#logo_preview').attr('src', data.logo + "?_=" + new Date().getTime());
                    }
                    if (data?.preview) {
                        $('#watermark_preview').attr('src', data.preview + "?_=" + new Date().getTime());
                    }
                },
                error: function(data) {
                    $("#pixjet_loader").hide();
                    var message = data.responseJSON?.message ?? 'Validation failed, Please reload the page and try again.';
                    Swal.fire({
                        title: 'Error!',
                        text: message,
                        icon: 'error',
                        confirmButtonText: 'OK'
					});
                }
            });
        });

        // Watermark Type Change Handler
        $("#watermark_type").on('change', function() {
            $("#image, #text, #opacity").removeAttr('required');
            $('[name="position"]').removeAttr('required');
            $(".show_text, .show_logo, .show_off").hide();
            if ($(this).val() === 'text') {
                $("#text, #opacity, [name='position']").attr('required', 'required');
                $(".show_text, .show_off").show();
            } else if ($(this).val() === 'logo') {
                $('#opacity, [name="position"]').attr('required', 'required');
                $(".show_logo, .show_off").show();
            }
        });

		disablePro();

		if ($("#is_pro").val() == 'pro') {
			enablePro();
		}
		
		$("#disconnect").on('click', function (e) {
			$(this).closest('form').submit();
		});

        // Initial Setup
        $('[name="position"]').is(':checked') && $('[name="position"]').trigger('change');
        $(".show_text, .show_logo, .show_off").hide();
        $("#watermark_type").trigger('change');
		$("#batch_optimize").on('click', batchOptimize);
		$("#batch_rollback").on('click', rollbackOptimize);

		$('#watermark_preview').on('error', function () {
			$(this).attr('src', pixjet?.url + '/admin/images/600x400.svg');
		});

		var watermark_src = $('#watermark_preview').attr('data-src');
		if (watermark_src) { 
			$('#watermark_preview').attr('src', watermark_src);
		}
	});


})(jQuery);